import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const Products = (props) => {
  // console.log('products', props)
  return (
    <>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        auctionName={props.location.state?.auctionName}
        laneName={props.location.state?.laneName}
        AuctionID={props.match.params.auctionID}
        LaneID={props.match.params.laneID}
        MediaState={props.match.params.mediaState}
      />
    </>
  );
};

export default observer(Products);
